module.exports = __webpack_public_path__ + "sc.74bd1af9.svg";